export class Option {
  disabled: boolean
  constructor(
    public id: number | string | boolean,
    public text: string,
    public value: any = null
  ) {
    if (value && (value.IsActive === false || value.Enabled === false)) {
      this.disabled = true
    }
  }
}
